import './config.css';
import 'react-datetime/css/react-datetime.css';
import ConfigurationForm from '../Forms/ConfigurationForm';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import copy from 'copy-to-clipboard';
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../context';
import { faSpinner, faLaptop, faClone, faBan, faDownload } from '@fortawesome/free-solid-svg-icons';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ConfigurationValue from '../Overview/PracticeOverview/Configuration/ConfigurationValue';
import hasPermission from '../Shared/hasPermission';
import toast from 'react-hot-toast';

// TODO: do a refactor later
const PracticeConfigurationModal = () => {
    const dispatch = useDispatch();
    const configPracticeId = useSelector(
        (state) => state.practice.practiceConfigModalWorkingPracticeId
    );
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);

    const [configurationData, setConfigurationData] = useState({});
    const [selectedPims, setSelectedPims] = useState('');
    const [isGeneratingInstaller, setIsGeneratingInstaller] = useState(false);
    const [configRefreshTimerId, setConfigRefreshTimerId] = useState(null);
    const isConnectConfigModalOpen = useSelector(
        (state) => state.toggle.isConnectConfigModalOpen
    );
    const practiceError = useSelector(
        (state) => state.practice.error
    );

    // this is a static value saved to an object in redux
    // TODO: put this into the db so can be managed through the UI?
    const pimsSettings = useSelector(
        (state) => state.pims.pimsSettings,
        shallowEqual
    );

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canManageInstaller = hasPermission('Installer', permissions);
    const canManageInsideDesk = hasPermission(
        'InsideDeskManageApiKey',
        permissions
    );

    // TODO: take this out of the use effect and instead grab value from redux
    // TODO: dispatch a fresh call in the open modal event, ConfigHeader component
    const refresh = () => {
        if (configPracticeId)
            dispatch(
                actions.practice.getPracticeConfiguration(configPracticeId)
            )
                .then((res) => {
                    setConfigurationData(res || {});
                    setSelectedPims((res?.pims || '').toUpperCase() || '');
                })
                .then(() => setEditing(false))
                .then(() => setLoading(false));
    };

    useEffect(() => {
        if (isConnectConfigModalOpen) {
            resetModal();
            setLoading(true);
            refresh();
        } else { // either way the modal is opening or closing, ensure the time is not running. 
            resetConfigRefreshTimer();
        }
        // eslint-disable-next-line
    }, [dispatch, isConnectConfigModalOpen]);

    useEffect(() => {
        if (isGeneratingInstaller) {
            // start a timer to pull configuration data every 2 seconds. 
            let timerId = setInterval(() => {
                refresh();
            }, 2000);

            // set the timerId in state. 
            setConfigRefreshTimerId(timerId);

            return () => { 
                clearInterval(timerId); 
            }
        } else {
            resetConfigRefreshTimer()
            return () => {  };
        }

    }, [isGeneratingInstaller])

    useEffect(() => {
        if (practiceError) {
            toast(
                () => (
                    <div className="text-light d-flex justify-content-between w-100">
                        {practiceError}
                    </div>
                ),
                {
                    duration: 7500,
                    style: {
                        minWidth:
                            '25vw',
                        background:
                            'red',
                    },
                }
            )
            dispatch(actions.practice.practiceError(null));
            resetModal();
            resetConfigRefreshTimer();
        }
    }, [practiceError, isGeneratingInstaller])

    useEffect(() => {
        if (isGeneratingInstaller) {            
            setIsGeneratingInstaller(false);
        }
    }, [configurationData.practiceInstallerUrl])

    //default editing mode is false
    //const [showAllFields, setShowAllFields] = useState(false);

    //resets to default settings
    const resetModal = () => {
        setEditing(false);
        setIsGeneratingInstaller(false);
    };

    const resetConfigRefreshTimer = () => {
        clearInterval(configRefreshTimerId);
        setConfigRefreshTimerId(null);
    }

    const toggleModal = () => {
        dispatch(actions.toggle.toggleConnectConfigModal(false));
        setEditing(false);
    };

    /**
     * Create installer file for practice
     */
    const generateInstaller = () => {
        setIsGeneratingInstaller(true);
        dispatch(actions.practice.createPracticeInstaller(configPracticeId));
    };

    const copyInstallerUrl = () => {
        copy(configurationData.practiceInstallerUrl || '');
        var elem = document.getElementById('installerText');
        elem.innerHTML = '&emsp;&emsp;Copied!';

        setTimeout(() => {
            elem.innerHTML = '';
        }, 1500);
    };

    const resetHardwareId = () => {
        dispatch(actions.practice.clearHardwareId(configPracticeId)).then(
            () => {
                var elem = document.getElementById('clickedText');
                if (elem != null) {
                    elem.innerHTML = 'Hardware ID was cleared';
                    setTimeout(() => (elem.innerHTML = ''), 2500);
                }
            }
        );
    };

    const displayConfigurationSetting = (settingList) =>
        settingList.includes(selectedPims.toUpperCase());

    const cancelEditing = () => setEditing(false);

    const closeEditing = () => refresh();

    const download = (url) => {
        const a = document.createElement('a')
        a.href = url
        a.download = url.split('/').pop()
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    const configView = () =>
        loading ? (
            <h3 className="text-center text-light">Loading...</h3>
        ) : (
            <>
                <ConfigurationValue
                    label="Ignoring Status?"
                    value={
                        configurationData?.ignoreStatus === true ? 'Yes' : 'No'
                    }
                />
                <ConfigurationValue
                    label="PIMS"
                    value={configurationData.pims}
                />
                <ConfigurationValue
                    label="Server Host Address"
                    value={configurationData.practiceHost}
                    hidden={
                        !configurationData?.practiceHost ||
                        !displayConfigurationSetting(pimsSettings.host)
                    }
                />
                <ConfigurationValue
                    label="PIMS Server Name"
                    value={configurationData.pmsServer}
                    hidden={
                        !configurationData?.pmsServer ||
                        !displayConfigurationSetting(pimsSettings.server)
                    }
                />
                <ConfigurationValue
                    label="PIMS Database Name"
                    value={configurationData.pmsDbName}
                    hidden={
                        !configurationData?.pmsDbName ||
                        !displayConfigurationSetting(pimsSettings.dbName)
                    }
                />
                <ConfigurationValue
                    label="PIMS Installation Directory"
                    value={configurationData.pmsDirectory}
                    hidden={
                        !configurationData?.pmsDirectory ||
                        !displayConfigurationSetting(pimsSettings.directory)
                    }
                />
                <ConfigurationValue
                    label="PIMS Username"
                    value={configurationData.pmsUser}
                    hidden={
                        !configurationData?.pmsUser ||
                        !displayConfigurationSetting(pimsSettings.dbUser)
                    }
                />
                <ConfigurationValue
                    label="PIMS Password"
                    value={configurationData.pmsPassword}
                    hidden={
                        (!configurationData?.pmsPassword && configurationData?.pmsPassword !== '') ||
                        !displayConfigurationSetting(pimsSettings.dbPassword)
                    }
                />
                {canManageInstaller && (
                    <>
                        <ConfigurationValue
                            label="Installer URL"
                            hidden={
                                (configurationData?.practiceInstallerUrl || '')
                                    .length === 0
                            }>
                            <Col
                                lg="8"
                                xs="12"
                                className={classNames(
                                    'd-flex justify-content-between hover-parent',
                                    {
                                        hoverable:
                                            configurationData
                                                .practiceInstallerUrl?.length >
                                            0,
                                    }
                                )}
                                >
                                <div onClick={copyInstallerUrl}>
                                    {configurationData.practiceInstallerUrl}
                                </div>
                                <div id="installerText">&nbsp;</div>
                                <Button className="hover-child bg-dark" onClick={copyInstallerUrl} >
                                    <FontAwesomeIcon
                                        
                                        icon={faClone}
                                    />
                                </Button>
                                <a  className="bg-dark btn btn-danger" role="button" target="_blank" href={configurationData.practiceInstallerUrl} >
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                    />
                                </a>
                            </Col>
                            
                        </ConfigurationValue>
                    </>
                )}
                <ConfigurationValue
                    label="Inside Desk Api Key"
                    value={configurationData.insideDeskApiKey}
                    hidden={
                        !(
                            configurationData.insideDeskConnected &&
                            canManageInsideDesk
                        ) ||
                        (configurationData?.insideDeskApiKey || '').length === 0
                    }
                />
                <Row className="mx-auto text-nowrap">
                    {canManageInstaller && (
                        <>
                            <Col xs="12" className="text-light mt-2">
                                <h5>Installation Functionality</h5>
                            </Col>
                            <Col
                                xs="12"
                                className="text-light mx-auto d-flex justify-content-start flex-wrap">
                                <Button
                                    className="m-2"
                                    color="info"
                                    disabled={isGeneratingInstaller}
                                    onClick={() => {
                                        generateInstaller();
                                    }}>
                                    {isGeneratingInstaller ? <FontAwesomeIcon icon={faSpinner} spin></FontAwesomeIcon> : <FontAwesomeIcon icon={faLaptop}></FontAwesomeIcon>}
                                    &emsp;
                                    {(!isGeneratingInstaller &&
                                        'Create Installer') ||
                                        (isGeneratingInstaller &&
                                            'Creating Installer...')}
                                </Button>
                                <Button
                                    className="m-2"
                                    color="info"
                                    onClick={resetHardwareId}>
                                    <FontAwesomeIcon icon={faBan} />
                                    &emsp;Clear Hardware ID
                                </Button>
                            </Col>
                        </>
                    )}
                    <Col xs="12" className="text-center">
                        <div id="clickedText" className="m-2 text-light"></div>
                        <span id="triggerText" className="text-light"></span>
                    </Col>
                </Row>
            </>
        );

    const modalStyle = {
        minWidth: '75vw',
    };

    return (
        <div>
            <Modal
                style={modalStyle}
                isOpen={isConnectConfigModalOpen}
                toggle={toggleModal}
                centered={true}>
                <ModalHeader className="justify-content-between text-light">
                    Practice Configuration
                </ModalHeader>
                {(!editing && (
                    <>
                        <ModalBody className="justify-content-center">
                            {configView()}
                        </ModalBody>
                        <ModalFooter className="justify-content-end">
                            <Button
                                color="primary"
                                onClick={() => setEditing(true)}>
                                Edit
                            </Button>
                            &emsp;
                            <Button color="info" onClick={() => toggleModal()}>
                                Close
                            </Button>
                        </ModalFooter>
                    </>
                )) || (
                    <ConfigurationForm
                        data={configurationData}
                        practiceId={configPracticeId}
                        cancelEditing={cancelEditing}
                        closeEditing={closeEditing}
                    />
                )}
            </Modal>
        </div>
    );
};

export default PracticeConfigurationModal;
